module.exports = __webpack_public_path__ + "img/video.4b8f4427.svg";